module.exports = __webpack_public_path__ + "img/m_ic_sns_insta.b8962d10.svg";